import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class TmsTasinirGirisBakiyeService {
  private _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public donem : number;
    public ambarKod : number;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(ambarKod?:number, donem?:number){
    this.donem = donem
    this.ambarKod=ambarKod
  }

     getDlist(formName:string):any {
      const request=new GetDlist_Request({
        dListCode:formName
      })
       this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
        tap(response => {
          this._gridControlsList.next(response.dListMetadata)
        }),
        catchError(err => throwError(err)),
        finalize(() => {})
      ).subscribe();
    }

  async getData(code: string, donem: number, ambarKod?:number, isSetData?: boolean) {
       this.donem=donem
    const dataSource = this.dataCoreService.getOData('vTmsTasinirGirisBakiye');
    dataSource.select([]);

    const filterArr = [];
    filterArr.push(['TasinirKod', '=', code]);
    if (donem) filterArr.push(['Donem', '=', donem]);
    if (ambarKod) filterArr.push(['AmbarKod', '=', ambarKod]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
